import type { Step } from "./Step.ts"
import {type FunctionComponent, useEffect, useState} from "react";
import type {Setter} from "../../util/setter/Setter.ts";

interface Result {
    currentStepId: number
    setCurrentStepId: Setter<number>
    Widget: FunctionComponent
}

export function useCurrentStep(steps: Step[]): Result {
    const [currentStep, setCurrentStep] = useState(0)
    const firstUnavailableStepIndex = steps.findIndex(step => !step.isAvailable)
    const highestAvailableStepIndex = firstUnavailableStepIndex < 0  ? (steps.length - 1) : (firstUnavailableStepIndex - 1)
    const currentStepIndex = Math.min(currentStep, highestAvailableStepIndex) // if the current step is not available, set it to the highest available step
    useEffect(() => {
        if(currentStepIndex < currentStep) {
            setCurrentStep(currentStepIndex)
        }
    }, [currentStep, setCurrentStep, currentStepIndex])
    const Widget = steps[currentStepIndex]?.Widget ?? (() => null)
    return {
        currentStepId: currentStepIndex,
        setCurrentStepId: setCurrentStep,
        Widget
    }
}